var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpto6Lines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#10ACE3",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F9F9F9",
    fillRule: "nonzero",
    width: 76,
    height: 76,
    rx: 38
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.731 29.153c0 3.398-2.643 6.153-6.224 6.153-3.58 0-6.224-2.755-6.224-6.153 0-3.398 2.644-6.153 6.224-6.153s6.224 2.755 6.224 6.153zM41.431 41.824c-.239-1.317-2.177-2.667-4.25-2.667h-9.47C23.454 39.157 20 42.57 20 46.78V53s25.199-.3 24.895 0M50.654 33.842c0 2.726-2.12 4.936-4.992 4.936-2.873 0-4.993-2.21-4.993-4.936s2.12-4.935 4.993-4.935c2.872 0 4.992 2.209 4.992 4.935z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.412 41.867h-7.598c-3.417 0-6.187 2.739-6.187 6.116v4.99s20.215-.241 19.971 0v-5.668M53.628 40.756v6.667M57 44.09h-6.744"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpto6Lines);
export default __webpack_public_path__ + "static/media/upto-6-lines.22264cc01b142cde649aac13648b1dc0.svg";
export { ForwardRef as ReactComponent };